//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const wordText_es = `comida
mantener
sentarse
siempre
jamás
hace
completo
carta
segundo
hoy
mañana
perro
cómico
fijar
tomar
alrededor
dio
amor
siete
ciudad
preguntar
puerta
va
quizás
mostrar
intentar
comió
vestido
verde
dinero
cantar
girar
cama
temprano
crecer
mismo
hermana
caminar
marrón
ocho
sombrero
ahora
sentar
caliente	
comprar
todo
feliz
seis
lavar
coche
ojos
difícil
dormir
agua`;

export default wordText_es;